import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const CardItem = ({ title, text, to, icon, iconSize = '5x', bg }) => {
  return (
    <Card
      as={Link}
      to={to}
      border="secondary"
      bg={bg}
      text={text}
      className="text-center"
    >
      <Card.Body>
        <Card.Img
          as={FontAwesomeIcon}
          variant="top"
          icon={icon}
          size={iconSize}
        />

        <Card.Title className="text-center">{title}</Card.Title>
      </Card.Body>
    </Card>
  );
};

export default CardItem;
